// extracted by mini-css-extract-plugin
export default {"colorPalette":"colorPalette__1lX1B","colorPaletteRow":"colorPaletteRow__msOu6","colorSwatch":"colorSwatch__wotNZ","colorSwatchSelected":"colorSwatchSelected__Nr3wk"};